<template>
  <div class="popup_in">
    <div class="popup pop-delete-block">
      <div class="popup_close">
        <a @click="close"><CloseSvg /></a>
      </div>
      <div class="ic-ok mb-15"><okSvg /></div>
      <div class="title title--55 bold">
        סיכום הייעוץ נשמר בהצלחה!
      </div>
      <div class="title--32 ft--300">
        ניתן לאתר בכל שלב את הסיכום בתור הרלוונטי ביומן
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import okSvg from "../../assets/img/svg/ok.svg";

export default {
  name: "ConfirmAddSummary",
  components: { CloseSvg, okSvg },
  methods: {
    close() {
      this.$emit("close");
      this.$router.push("/app-info/" + this.$route.params.id);
    }
  }
};
</script>
